import { captureProductEventClient } from '@/lib/telemetry/product-events-client'

type SignOutError = {
  message?: string
}

type SupabaseSignOutClient = {
  auth: {
    signOut: () => Promise<{ error: SignOutError | null }>
  }
}

type Logger = (message?: unknown, ...optionalParams: unknown[]) => void

export async function signOutOrThrow(supabase: SupabaseSignOutClient): Promise<void> {
  const { error } = await supabase.auth.signOut()
  if (error) {
    throw new Error(error.message ?? "Failed to sign out")
  }
}

export async function signOutAndRedirectOnSuccess(params: {
  signOut: () => Promise<void>
  redirect: (path: string) => void
  logger?: Logger
  path?: string
  surface?: string
}): Promise<boolean> {
  const {
    signOut,
    redirect,
    logger = console.error,
    path = '/auth/login',
    surface = 'dashboard_sidebar',
  } = params

  try {
    await signOut()
    redirect(path)
    void captureProductEventClient({
      event: 'auth_signout_clicked',
      action: 'sign_out',
      result: 'success',
      surface,
    })
    return true
  } catch (error) {
    logger("Failed to sign out", error)
    void captureProductEventClient({
      event: 'auth_signout_clicked',
      action: 'sign_out',
      result: 'failure',
      surface,
      error,
    })
    return false
  }
}
